import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const CaseStudyCTA = () => {
  return (
    <section className="bg-fordje-navy py-12 md:py-16 border-b border-white/10">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center animate-fade-in">
          <h2 className="text-white mb-6">
            Build without <span className="gradient-text">surprises.</span>
          </h2>
          <Link to="/request-demo">
            <Button
              size="lg"
              className="text-lg px-8 py-6 bg-gradient-to-r from-fordje-blue to-fordje-accent hover:from-fordje-blue-dark hover:to-fordje-blue shadow-lg shadow-fordje-blue/20"
            >
              Book a Demo <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CaseStudyCTA;
